
import Vue from 'vue';

// see https://cn.vuejs.org/v2/guide/components.html#非父子组件通信
let bus=new Vue();

export default bus;


// WEBPACK FOOTER //
// ./src/libs/bus.js